export const crm = {
  it: {
    layout: {
      expandSidebar: 'Espandi sidebar',
      collapseSidebar: 'Comprimi sidebar',
      closeMenu: 'Chiudi menu',
      back: 'Indietro',
      openMenu: 'Apri menu',
      poweredBy: 'Powered by',
      loadingWorkspace: 'Caricamento workspace…'
    },
    navigation: {
      brand: 'Sales Navigator',
      contacts: 'Contatti',
      leads: 'Lead',
      prospezione: 'Prospezione',
      navigator: 'Navigatore',
      appointments: 'Appuntamenti',
      reports: 'Report',
      settings: 'Impostazioni · Utenti',
      logout: 'Esci'
    },
    common: {
      loading: 'Caricamento…',
      searchPlaceholder: 'Cerca nome/email/telefono',
      filterSource: 'Sorgente',
      filterTag: 'Tag',
      filterStage: 'Tipo',
      sortRecent: 'Più recenti',
      sortName: 'Ordina per nome',
      buttons: {
        new: 'Nuovo',
        create: 'Crea',
        save: 'Salva',
        edit: 'Modifica',
        delete: 'Elimina',
        cancel: 'Annulla',
        close: 'Chiudi',
        open: 'Apri'
      },
      stages: {
        contact: 'Contatto',
        lead: 'Lead',
        client: 'Cliente',
        prospect: 'Prospect'
      },
      relative: {
        today: 'oggi',
        yesterday: 'ieri',
        daysAgo: '{{count}}g fa'
      },
      openLeadBadge: '{{count}} lead',
      selected: '{{count}} selezionati'
    },
    contacts: {
      title: 'Contatti',
      subtitle: 'Gestisci la rubrica e verifica attività e duplicati.',
      newButton: 'Nuovo contatto',
      summary: '{{count}} risultati · duplicati email: {{duplicateEmails}} · duplicati telefono: {{duplicatePhones}}',
      columns: {
        name: 'Nome',
        company: 'Ragione Sociale',
        email: 'Email',
        phone: 'Telefono',
        source: 'Origine',
        stage: 'Tipo',
        address: 'Indirizzo',
        city: 'Città',
        prospectStatus: 'Status Prospezione',
        leadStatus: 'Status Lead',
        tags: 'Tag',
        interest_level: 'Livello Interesse',
        route_index: 'Indice Percorso',
        vat: 'P.IVA',
        rank: 'Rank',
        lastActivity: 'Ultima attività',
        website: 'Website',
        googleMaps: 'Google Maps',
        whatsapp: 'WhatsApp',
        latest_note: 'Nota',
        actions: 'Azioni'
      },
      noTag: '—',
      noRank: 'Non assegnato',
      duplicateBadge: 'dup',
      addToNavigator: 'Aggiungi al Navigatore',
      alreadyInNavigator: 'Già nel Navigatore',
      addedToNavigator: 'Contatto aggiunto al Navigatore',
      drawer: {
        newTitle: 'Nuovo contatto',
        editTitle: 'Modifica contatto',
        fullName: 'Nome completo',
        email: 'Email',
        phone: 'Telefono',
        source: 'Origine',
        tags: 'Tag (separati da virgola)',
        vat: 'Partita IVA',
        rank: 'Rank cliente',
        rankPlaceholder: 'Non assegnato',
        stage: 'Tipo',
        typeLabel: 'Tipo',
        leadStatusLabel: 'Status Lead',
        prospectStatusLabel: 'Status Prospezione',
        contactTypeOption: 'Contatto',
        leadTypeOption: 'Lead',
        prospectTypeOption: 'Prospect'
      },
      delete: {
        title: 'Elimina contatto',
        message: 'Sei sicuro di voler eliminare {{name}}? L’operazione non è reversibile.',
        confirm: 'Elimina',
        cancel: 'Annulla',
        error: 'Errore eliminazione: {{message}}'
      },
      import: 'Importa',
      findCoordinates: 'Trova Coordinate',
      findCoordinatesFor: 'Trova coordinate per {{count}} contatti',
      fixing: 'Correzione…',
      updateCity: 'Aggiorna Città',
      updateCityFor: 'Aggiorna città per {{count}} contatti',
      updating: 'Aggiornamento…',
      optimizeRoute: 'Ottimizza Percorso',
      optimizeRouteFor: 'Ottimizza percorso e assegna indici per {{count}} contatti',
      optimizing: 'Ottimizzazione…',
      noTagsAvailable: 'Nessun tag disponibile',
      noCitiesAvailable: 'Nessuna città disponibile',
      importList: 'Importa Lista',
      pagination: { showing: 'Mostrando', of: 'di', contacts: 'contatti', previous: 'Precedente', prevShort: 'Prev', next: 'Successivo', nextShort: 'Next' },
      previous: 'Precedente',
      prevShort: 'Prev',
      next: 'Successivo',
      nextShort: 'Next',
      placeholderCompany: 'Azienda',
      placeholderRole: 'Ruolo',
      interestLevelLabel: 'Livello Interesse',
      interestLevelLow: 'Basso',
      interestLevelMedium: 'Medio',
      interestLevelHigh: 'Alto',
      routeIndexPlaceholder: 'Indice Percorso',
      routeIndexAsc: 'Indice Percorso (Cresc.)',
      routeIndexDesc: 'Indice Percorso (Decr.)',
      importListTitle: 'Importa Lista Contatti',
      validMapsUrl: 'Inserisci un URL Google Maps valido',
      coordinatesFound: 'Posizione trovata: {{lat}}, {{lng}}',
      coordinatesExtractError: 'Impossibile estrarre le coordinate. Usa un link Google Maps valido.',
      noContactsToFix: 'Nessun contatto da correggere! Tutti i contatti hanno già le coordinate.',
      processingContacts: 'Elaborazione di {{count}} contatti...',
      clearAllFilters: 'Rimuovi tutti i filtri',
      addColumn: 'Aggiungi colonna',
      hiddenColumns: 'Colonne nascoste',
      filterColumn: 'Filtra {{label}}',
      searchPlaceholder: 'Cerca...',
      hideColumn: 'Nascondi colonna',
      viewDetails: 'Visualizza Dettagli',
      noteLabel: 'Note',
      toasts: {
        noContactsToFix: 'Nessun contatto da correggere! Tutti i contatti hanno già le coordinate.',
        processingCount: 'Elaborazione di {{count}} contatti...',
        coordsUpdatedFor: 'Coordinate aggiornate per {{name}}',
        batchCompleteCoords: 'Batch completato! Aggiornati {{count}} contatti nel database.',
        noContactsToUpdate: 'Nessun contatto da aggiornare! Tutti i contatti con coordinate hanno già la città.',
        cityUpdatedFor: 'Città aggiornata per {{name}}: {{city}}',
        batchCompleteCity: 'Batch completato! Aggiornate {{count}} città nel database.',
        noContactsForRoute: 'Nessun contatto con coordinate disponibili per l\'ottimizzazione del percorso.',
        optimizingRoute: 'Ottimizzazione percorso per {{count}} contatti...',
        cannotDetermineStart: 'Impossibile determinare il punto di partenza.',
        routeOptimized: 'Ottimizzazione completata! {{count}} contatti indicizzati.',
        routeError: 'Errore durante l\'ottimizzazione: {{message}}'
      },
      empty: {
        noResults: 'Nessun contatto trovato',
        noContactsYet: 'Nessun contatto ancora',
        tryFilters: 'Prova a modificare i filtri di ricerca o aggiungi un nuovo contatto.',
        addFirst: 'Inizia aggiungendo il tuo primo contatto o importando una lista.'
      },
      importModal: {
        uploadHint: 'Carica un file Excel (.xlsx) o CSV. Il file Excel deve contenere il foglio "Recovered_Sheet1" con queste colonne:',
        noValidContacts: 'Nessun contatto valido trovato nel file',
        importedWithoutWebsite: 'Importati {{count}} contatti (senza campo Website - colonna non presente nel database).\n\nPer abilitare il campo Website, esegui la migrazione SQL nel file: supabase-migration-add-website-column.sql',
        importedCount: 'Importati {{count}} contatti',
        importError: 'Errore durante l\'import: {{message}}',
        importErrorWebsite: 'Errore durante l\'import: {{message}}\n\nNota: La colonna \'website\' non esiste nel database. Esegui la migrazione SQL per aggiungerla.',
        contactCreatedWithoutWebsite: 'Contatto creato (senza campo Website - colonna non presente nel database).\n\nPer abilitare il campo Website, esegui la migrazione SQL nel file: supabase-migration-add-website-column.sql',
        contactUpdatedWithoutWebsite: 'Contatto aggiornato (senza campo Website - colonna non presente nel database).\n\nPer abilitare il campo Website, esegui la migrazione SQL nel file: supabase-migration-add-website-column.sql',
        sheetNotFound: 'Foglio "Recovered_Sheet1" non trovato nel file Excel',
        excelNeedsHeader: 'Il file Excel deve contenere almeno un header e una riga di dati',
        excelNeedsCompanyColumn: 'Il file Excel deve contenere la colonna "Ragione Sociale".\n\nColonne trovate: {{columns}}',
        csvNeedsHeader: 'CSV deve contenere almeno un header e una riga di dati',
        csvNeedsNameColumn: 'CSV deve contenere una colonna "Nome Attività" o "Name"'
      }
    },
    leads: {
      title: 'Lead',
      subtitle: 'Monitora pipeline, metriche e attività.',
      newLead: 'Nuovo lead',
      na: 'N/D',
      searchPlaceholder: 'Cerca per titolo o contatto',
      filters: {
        stage: 'Stage',
        duplicates: 'Possibili duplicati'
      },
      defaults: {
        untitled: 'Lead senza titolo',
        fallbackTitle: 'Lead',
        noName: 'Senza nome',
        linkedContact: 'Contatto collegato'
      },
      createError: 'Errore creazione lead: {{message}}',
      deleteError: 'Errore eliminazione lead: {{message}}',
      kpi: {
        totalContacts: 'Contatti totali',
        totalLeads: 'Lead totali',
        scheduled: 'Appuntamenti programmati',
        completed: 'Appuntamenti conclusi',
        noShow: 'Assenze',
        conversion: 'Tasso di conversione',
        conversionDetail: '{{won}} vinti su {{total}}'
      },
      pipelineSummary: 'Distribuiti: {{breakdown}}',
      kpiSummary: 'Completati: {{completed}} · No-show: {{noShow}}',
      pipeline: {
        headings: {
          new: 'Nuovi',
          qualified: 'Qualificati',
          scheduled: 'Schedulati',
          won: 'Vinti',
          lost: 'Persi'
        },
        empty: 'Trascina qui i lead per aggiornarne lo stato',
        staleBadge: 'da follow-up',
        duplicateBadge: 'dup',
        duplicateMessage: 'Contatto duplicato nel funnel',
        unassigned: 'Contatto non associato',
        lastUpdate: 'Ultimo update',
        source: 'Origine',
        emptyColumn: 'Nessun lead in questa colonna.'
      },
      followUps: {
        title: 'Follow-up da fare',
        empty: 'Tutto aggiornato!'
      },
      modal: {
        newTitle: 'Nuovo lead',
        editTitle: 'Modifica lead',
        titleLabel: 'Titolo',
        valueLabel: 'Valore (EUR)',
        stageLabel: 'Stage',
        selectContact: 'Seleziona contatto',
        newContactHeading: 'Crea nuovo contatto',
        contactName: 'Nome',
        contactPhone: 'Telefono',
        contactEmail: 'Email',
        notes: 'Note interne',
        notesPlaceholder: 'Aggiungi note, dettagli o informazioni rilevanti sul lead...',
        attachedContact: 'Contatto collegato',
        addLead: 'Crea lead',
        saveLead: 'Salva',
        cancel: 'Annulla',
        deleteTitle: 'Elimina lead',
        deleteText: 'Vuoi davvero eliminare {{title}}? L\'azione è irreversibile.',
        details: 'Dettagli',
        linkContact: 'Collega contatto',
        singleMode: 'Modalità singolo',
        multiMode: 'Modalità multipla',
        contactDetailsNote: 'I dettagli del contatto si modificano dalla scheda contatto.',
        orCreateNew: '…oppure crea un nuovo contatto',
        remove: 'Rimuovi',
        loading: 'Caricamento…',
        selected: 'selezionati'
      }
    },
    appointments: {
      title: 'Agenda e appuntamenti',
      subtitle: 'Scheduling & Appointments',
      description: 'Gestisci slot, prenotazioni e promemoria automatici.',
      calendarSync: {
        title: 'Sincronizzazione calendario',
        heading: 'Connetti il tuo calendario',
        description: 'Salva il link del calendario (ICS o CalDAV) per mantenere gli appuntamenti Launch allineati con il tuo programma personale.',
        status: 'Stato',
        edit: 'Modifica',
        displayName: 'Nome visualizzato',
        displayNamePlaceholder: 'es. Victor – Outlook',
        provider: 'Provider',
        providerManual: 'Manuale (link ICS)',
        providerMicrosoft: 'Microsoft 365',
        providerCalendly: 'Calendly',
        icsLink: 'Link ICS / prenotazione',
        icsLinkPlaceholder: 'https://...',
        saveConnection: 'Salva connessione'
      },
      buildAvailability: {
        title: 'Crea disponibilità',
        description: 'Aggiungi slot temporali che il sistema può prenotare automaticamente quando i lead scelgono un orario.',
        startDateTime: 'Data e ora di inizio',
        duration: 'Durata (minuti)',
        calendar: 'Calendario',
        internalNotes: 'Note interne',
        internalNotesPlaceholder: 'Dettagli opzionali per il team',
        addSlot: 'Aggiungi slot'
      },
      availableSlots: {
        title: 'Slot disponibili',
        subtitle: 'Pronti per la prenotazione',
        empty: 'Nessuna disponibilità ancora. Aggiungi uno slot a sinistra per rendere disponibili le finestre di prenotazione.',
        open: '{{count}} aperti',
        book: 'Prenota',
        cancel: 'Annulla'
      },
      bookedSlots: {
        title: 'Slot prenotati'
      },
      upcoming: {
        title: 'Prossimi appuntamenti',
        subtitle: 'Prossimi 20 appuntamenti',
        scheduled: '{{count}} programmati',
        empty: 'Quando uno slot disponibile viene prenotato, apparirà qui con i dettagli del contatto e lo stato.',
        when: 'Quando',
        contact: 'Contatto',
        subject: 'Titolo',
        status: 'Stato',
        actions: 'Azioni',
        join: 'Partecipa',
        done: 'Completato',
        cancel: 'Annulla'
      },
      modal: {
        bookTitle: 'Prenota slot',
        existingContact: 'Contatto esistente',
        selectContact: 'Seleziona contatto…',
        selectContactNone: 'Nessuno',
        searchContactPlaceholder: 'Cerca contatto...',
        orCreateNew: 'Oppure crea nuovo',
        fullName: 'Nome completo',
        phone: 'Telefono',
        phonePlaceholder: '+39 333…',
        email: 'Email (opzionale)',
        emailPlaceholder: 'client@example.com',
        title: 'Titolo',
        titlePlaceholder: 'Chiamata di consulenza',
        notes: 'Note',
        notesPlaceholder: 'Agenda breve',
        cancel: 'Annulla',
        confirmBooking: 'Conferma prenotazione'
      },
      errors: {
        loadData: 'Impossibile caricare i dati di pianificazione',
        createSlot: 'Impossibile creare lo slot',
        cancelSlot: 'Impossibile annullare lo slot',
        bookAppointment: 'Impossibile prenotare l\'appuntamento',
        updateAppointment: 'Impossibile aggiornare l\'appuntamento',
        deleteAppointment: 'Impossibile eliminare l\'appuntamento',
        deleteSlot: 'Impossibile eliminare lo slot',
        saveConnection: 'Impossibile salvare la connessione del calendario',
        selectContact: 'Seleziona un contatto esistente o fornisci i dettagli per uno nuovo.',
        contactCreationFailed: 'Creazione contatto fallita'
      },
      loading: 'Caricamento dati di pianificazione…',
      delete: {
        title: 'Elimina appuntamento',
        confirm: 'Sei sicuro di voler eliminare questo appuntamento? Questa azione non può essere annullata.',
        button: 'Elimina'
      },
      deleteSlot: {
        title: 'Elimina slot',
        confirm: 'Sei sicuro di voler eliminare questo slot prenotato? Verrà eliminato anche l\'appuntamento associato se presente. Questa azione non può essere annullata.'
      }
    },
    reports: {
      title: 'Report',
      subtitle: 'Panoramica KPI e trend delle conversazioni.',
      loading: 'Caricamento metriche…',
      empty: 'Nessun dato KPI disponibile ancora. Le interazioni catturate tramite WhatsApp, contatti e appuntamenti appariranno qui automaticamente.',
      cards: {
        inboundMessages: 'Messaggi in ingresso',
        contactsCaptured: 'Contatti acquisiti',
        leadsCreated: 'Lead creati',
        appointmentsCompleted: 'Appuntamenti completati',
        avgFirstResponse: 'Tempo medio prima risposta',
        vsPrevious: 'vs precedente'
      },
      charts: {
        messagingVolume: 'Volume messaggi',
        pipelineVelocity: 'Velocità pipeline'
      },
      table: {
        date: 'Data',
        period: 'Periodo',
        inbound: 'In ingresso',
        outbound: 'In uscita',
        contacts: 'Contatti',
        leads: 'Lead',
        appointments: 'Appuntamenti',
        avgResponse: 'Tempo medio risposta',
        completed: 'Appuntamenti completati'
      }
    },
    settings: {
      title: 'Impostazioni · Utenti',
      subtitle: 'Gestisci gli accessi al workspace.',
      users: {
        title: 'Utenti',
        loading: 'Caricamento…',
        adminOnly: 'Solo gli amministratori possono accedere a questa pagina.',
        email: 'Email',
        name: 'Nome',
        role: 'Ruolo',
        lastLogin: 'Ultimo accesso',
        actions: 'Azioni',
        resetPassword: 'Reimposta password',
        resetPasswordSending: 'Invio…',
        delete: 'Elimina',
        deleteRemoving: 'Rimozione…'
      },
      invite: {
        title: 'Invita nuovo utente',
        email: 'Email',
        emailPlaceholder: 'Email',
        fullName: 'Nome completo',
        fullNamePlaceholder: 'Nome completo',
        role: 'Ruolo',
        temporaryPassword: 'Password temporanea',
        temporaryPasswordPlaceholder: 'Password temporanea',
        sendEmail: 'Invia email di invito (l\'utente definisce la password)',
        passwordInstructions: 'Un\'email chiederà all\'utente di scegliere la propria password.',
        passwordManual: 'Condividi questa password manualmente. Nessuna email verrà inviata.',
        inviteButton: 'Invita'
      },
      roleOptions: {
        owner: 'owner',
        admin: 'admin',
        agent: 'agent',
        viewer: 'viewer'
      },
      alerts: {
        notAllowed: 'Non consentito',
        missingWorkspace: 'Workspace mancante',
        inviteFailed: 'Invito fallito',
        resetSuccess: 'Email di reset password inviata',
        deleteSuccess: 'Utente rimosso',
        confirmDelete: 'Sei sicuro di voler rimuovere questo utente?',
        roleChangeFailed: 'Modifica ruolo fallita',
        userHasNoEmail: 'L\'utente non ha email',
        resetConfirmSelf: 'Stai per inviare a te stesso un\'email di reset password. Continuare?',
        resetConfirmOther: 'Inviare email di reset password a {{email}}?',
        sessionExpired: 'Sessione scaduta. Effettua nuovamente l\'accesso.',
        unableToSendReset: 'Impossibile inviare email di reset',
        resetSentSuccess: 'Email inviata. Chiedi all\'utente di controllare la casella (e la cartella spam).',
        removeAccessConfirm: 'Rimuovere l\'accesso per {{email}}? L\'utente non potrà più accedere.',
        deleteSelfConfirm: 'Stai eliminando il tuo accesso. Verrai disconnesso. Continuare?',
        unableToDeleteUser: 'Impossibile eliminare l\'utente'
      },
      pagination: {
        showing: 'Mostrando',
        of: 'di',
        users: 'utenti',
        previous: 'Precedente',
        prevShort: 'Prev',
        next: 'Successivo',
        nextShort: 'Next'
      },
      roleLabel: 'Ruolo',
      moreOptions: 'Altre opzioni'
    },
    detail: {
      contact: {
        timeline: 'Cronologia attività',
        newNote: 'Aggiungi nota',
        placeholder: 'Aggiungi una nota...',
        save: 'Salva nota',
        loading: 'Caricamento…',
        deleteNoteConfirm: 'Sei sicuro di voler eliminare questa nota?',
        source: 'Origine',
        company: 'Azienda',
        address: 'Indirizzo',
        openGoogleMaps: 'Apri su Google Maps →',
        prospectStatus: 'Status Prospezione',
        vat: 'P.IVA / VAT',
        rank: 'Rank',
        edit: 'Modifica',
        editDetails: 'Modifica dettagli',
        additionalInfo: 'Info aggiuntive',
        created: 'Creato',
        lastActivity: 'Ultima attività',
        preferredLanguagePlaceholder: 'Lingua preferita',
        zipPlaceholder: 'CAP',
        googleMapsUrlPlaceholder: 'URL Google Maps',
        addNoteButton: 'Aggiungi',
        noActivityYet: 'Nessuna attività ancora.',
        deleteNoteTitle: 'Elimina nota'
      },
      lead: {
        contactCard: 'Contatto collegato',
        timeline: 'Cronologia attività',
        newNote: 'Aggiungi nota',
        placeholder: 'Aggiungi una nota...',
        save: 'Salva nota',
        loading: 'Caricamento…',
        back: 'Indietro',
        untitledLead: 'Lead senza titolo',
        potentialValue: 'Valore potenziale: €',
        lastUpdate: 'Ultimo aggiornamento',
        deleteNoteConfirm: 'Sei sicuro di voler eliminare questa nota?',
        lostReason: 'Motivo perdita',
        lostReasonNotDocumented: 'Non ancora documentato.',
        whyLoseDeal: 'Perché abbiamo perso questo affare?',
        saveLostReason: 'Salva motivo perdita',
        markLost: 'Segna come perso',
        hide: 'Nascondi',
        dealHygiene: 'Igiene affare',
        appointments: 'Appuntamenti',
        notesPlaceholder: 'Es: riepilogo telefonata, prossimi passi, dettagli su budget',
        noActivityYet: 'Nessuna attività ancora.'
      },
      activityTypes: {
        whatsapp_inbound: 'WhatsApp (in entrata)',
        whatsapp_outbound: 'WhatsApp (in uscita)',
        review_request_sent: 'Richiesta recensione',
        appointment_reminder: 'Promemoria appuntamento',
        note: 'Nota',
        activity: 'Attività'
      },
      activityChannels: {
        automation: 'Automazione',
        web: 'CRM',
        whatsapp: 'WhatsApp'
      }
    },
    prospezione: {
      title: 'Prospezione',
      subtitle: 'Gestisci la tua lista di contatti da visitare',
      noContacts: 'Nessun contatto',
      createCheckup: 'Crea Check-up',
      createCheckupTitle: 'Crea Check-up',
      createCheckupMessage: 'Creerai un Lead e un Appuntamento per questo contatto. Vuoi procedere?',
      createCheckupConfirm: 'Crea Check-up',
      createCheckupCancel: 'Annulla',
      details: 'Dettagli',
      openMaps: 'Apri su Maps',
      noName: 'Senza nome',
      stages: {
        new: 'Nuovo',
        to_visit: 'Da Visitare',
        visited_interested: 'Visitato - Interessato',
        visited_not_interested: 'Visitato - Non Interessato',
        nurture: 'Da Ricontattare',
        disqualified: 'Disqualificato'
      },
      activity: {
        coldVisit: 'Visita a freddo'
      },
      kpi: {
        totalProspects: 'Prospect Totali',
        conversionRate: 'Tasso di Conversione',
        visits: 'Visite',
        followUpDue: 'Follow-up da Fare',
        distributed: 'Distribuiti',
        interestedOutOf: '{{interested}} interessati su {{total}} totali',
        completed: 'Completate',
        toVisit: 'Da visitare',
        allUpToDate: 'Tutto aggiornato!'
      },
      addProspect: 'Aggiungi Prospect',
      editProspect: 'Modifica Prospect',
      newProspect: 'Nuovo Prospect',
      searchExistingContacts: 'Cerca Contatti Esistenti',
      leadCreationError: 'Errore creazione lead: {{message}}',
      contactUpdateError: 'Errore aggiornamento contatti: {{message}}',
      updateError: 'Errore aggiornamento: {{message}}',
      createError: 'Errore creazione: {{message}}'
    },
    navigator: {
      title: 'Navigatore',
      subtitle: 'Seleziona fino a 10 contatti e visualizza il percorso ottimizzato',
      addContact: 'Aggiungi Contatto',
      selectContact: 'Seleziona Contatto',
      selectedContacts: 'Contatti Selezionati',
      noContactsSelected: 'Nessun contatto selezionato',
      selectContactsHint: 'Clicca su "Aggiungi Contatto" per iniziare',
      generateRoute: 'Genera Percorso',
      navigate: 'Naviga',
      clear: 'Pulisci',
      remove: 'Rimuovi',
      maxReached: 'Hai raggiunto il limite massimo di 10 contatti',
      noValidPoints: 'Nessun punto valido con coordinate',
      noAvailableContacts: 'Nessun contatto disponibile con Google Maps URL',
      noName: 'Senza nome',
      removeConfirm: 'Rimuovere questo contatto dalla lista?',
      moveUp: 'Sposta su',
      moveDown: 'Sposta giù',
      openInGoogleMaps: 'Apri in Google Maps',
      openMaps: 'Apri Maps',
      resetRoute: 'Reset percorso',
      reset: 'Reset',
      clearList: 'Pulisci lista',
      actions: 'Azioni',
      interested: 'Interessato',
      notInterested: 'Non Interessato',
      visitDetailsPlaceholder: 'Inserisci dettagli sulla visita...',
      visitOutcome: 'Esito Visita',
      addVisitDetailsPlaceholder: 'Aggiungi dettagli sulla visita...',
      confirmOutcome: 'Conferma Esito',
      searchPlaceholder: 'Cerca per nome, azienda, email, telefono...',
      visitedShort: 'Visitato',
      moveUpShort: 'Su',
      moveDownShort: 'Giù',
      optimize: 'Ottimizza',
      optimizeRouteButton: 'Ottimizza Percorso',
      optimizing: 'Ottimizzazione…',
      gettingLocation: 'Ottenendo…',
      contactCount: '{{count}} contatto',
      contactCountPlural: '{{count}} contatti',
      contactSingular: 'contatto',
      contactPlural: 'contatti',
      stepCount: '{{count}} tappa',
      stepCountPlural: '{{count}} tappe',
      dragToReorder: 'Trascina per riordinare',
      shortLink: 'Link breve',
      missingCoordinates: 'Coordinate mancanti',
      howDidVisitGo: 'Com\'è andata la visita?',
      visitNotesOptional: 'Note Visita (Opzionale)',
      notesOptional: 'Note (opzionale)',
      saving: 'Salvataggio…',
      confirmVisit: 'Conferma Visita',
      searchContactsTitle: 'Cerca Contatti, Lead o Prospect',
      searchContactsHint: 'Cerca tra contatti, lead e prospect con indirizzo Google Maps',
      noSearchResults: 'Nessun risultato trovato. Prova con altri termini di ricerca.',
      visitOutcomeNote: 'Esito visita: {{outcome}}',
      visitNotesLabel: 'Note',
      selectAtLeastOne: 'Seleziona almeno un contatto',
      maxContactsReached: 'Puoi aggiungere solo {{n}} contatto/i (massimo 10 totali)',
      optimizedRoute: 'Percorso Ottimizzato',
      optimizeFailed: 'Impossibile ottimizzare il percorso...',
      optimizeFailedWithCoords: 'Impossibile ottimizzare il percorso. Assicurati che i contatti abbiano coordinate valide.',
      optimizeFirst: 'Percorso non ottimizzato. Clicca prima su "Ottimizza Percorso".',
      saveError: 'Si è verificato un errore durante il salvataggio. Riprova.',
      clearAllConfirm: 'Sei sicuro di voler rimuovere tutti i contatti dalla lista?',
      errorPrefix: 'Errore',
      convertToProspect: 'Converti in Prospect',
      convertToClient: 'Converti in Cliente',
      selectedCount: '{{n}} selezionato',
      selectedCountPlural: '{{n}} selezionati',
      slotsAvailable: '{{n}} slot disponibili',
      deselect: 'Deseleziona',
      addWithCount: 'Aggiungi ({{n}})',
      add: 'Aggiungi',
      shortLinkNoCoords: 'Link breve: coordinate non estraibili'
    }
  },
  en: {
    layout: {
      expandSidebar: 'Expand sidebar',
      collapseSidebar: 'Collapse sidebar',
      closeMenu: 'Close menu',
      back: 'Back',
      openMenu: 'Open menu',
      poweredBy: 'Powered by',
      loadingWorkspace: 'Loading workspace…'
    },
    navigation: {
      brand: 'Sales Navigator',
      contacts: 'Contacts',
      leads: 'Leads',
      prospezione: 'Prospecting',
      navigator: 'Navigator',
      appointments: 'Appointments',
      reports: 'Reports',
      settings: 'Settings · Users',
      logout: 'Logout'
    },
    common: {
      loading: 'Loading…',
      searchPlaceholder: 'Search name/email/phone',
      filterSource: 'Source',
      filterTag: 'Tag',
      filterStage: 'Type',
      sortRecent: 'Most recent',
      sortName: 'Sort by name',
      buttons: {
        new: 'New',
        create: 'Create',
        save: 'Save',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
        close: 'Close',
        open: 'Open'
      },
      stages: {
        contact: 'Contact',
        lead: 'Lead',
        client: 'Client',
        prospect: 'Prospect'
      },
      relative: {
        today: 'today',
        yesterday: 'yesterday',
        daysAgo: '{{count}}d ago'
      },
      openLeadBadge: '{{count}} lead',
      selected: '{{count}} selected'
    },
    contacts: {
      title: 'Contacts',
      subtitle: 'Manage records and monitor activity & duplicates.',
      newButton: 'New contact',
      summary: '{{count}} results · email duplicates: {{duplicateEmails}} · phone duplicates: {{duplicatePhones}}',
      columns: {
        name: 'Name',
        company: 'Company Name',
        email: 'Email',
        phone: 'Phone',
        source: 'Source',
        stage: 'Stage',
        address: 'Address',
        city: 'City',
        prospectStatus: 'Prospect Status',
        leadStatus: 'Lead Status',
        tags: 'Tags',
        interest_level: 'Interest Level',
        route_index: 'Route Index',
        vat: 'VAT',
        rank: 'Rank',
        lastActivity: 'Last Activity',
        website: 'Website',
        googleMaps: 'Google Maps',
        whatsapp: 'WhatsApp',
        latest_note: 'Note',
        actions: 'Actions'
      },
      noTag: '—',
      noRank: 'Not set',
      duplicateBadge: 'dup',
      addToNavigator: 'Add to Navigator',
      alreadyInNavigator: 'Already in Navigator',
      addedToNavigator: 'Contact added to Navigator',
      drawer: {
        newTitle: 'New contact',
        editTitle: 'Edit contact',
        fullName: 'Full name',
        email: 'Email',
        phone: 'Phone',
        source: 'Source',
        tags: 'Tags (comma separated)',
        vat: 'VAT number',
        rank: 'Client rank',
        rankPlaceholder: 'Not set',
        stage: 'Type',
        typeLabel: 'Type',
        leadStatusLabel: 'Lead Status',
        prospectStatusLabel: 'Prospect Status',
        contactTypeOption: 'Contact',
        leadTypeOption: 'Lead',
        prospectTypeOption: 'Prospect'
      },
      delete: {
        title: 'Delete contact',
        message: 'Are you sure you want to delete {{name}}? This action cannot be undone.',
        confirm: 'Delete',
        cancel: 'Cancel',
        error: 'Delete error: {{message}}'
      },
      import: 'Import',
      findCoordinates: 'Find Coordinates',
      findCoordinatesFor: 'Find coordinates for {{count}} contacts',
      fixing: 'Fixing…',
      updateCity: 'Update City',
      updateCityFor: 'Update city for {{count}} contacts',
      updating: 'Updating…',
      optimizeRoute: 'Optimize Route',
      optimizeRouteFor: 'Optimize route and assign indices for {{count}} contacts',
      optimizing: 'Optimizing…',
      noTagsAvailable: 'No tags available',
      noCitiesAvailable: 'No cities available',
      importList: 'Import List',
      pagination: { showing: 'Showing', of: 'of', contacts: 'contacts', previous: 'Previous', prevShort: 'Prev', next: 'Next', nextShort: 'Next' },
      previous: 'Previous',
      prevShort: 'Prev',
      next: 'Next',
      nextShort: 'Next',
      placeholderCompany: 'Company',
      placeholderRole: 'Role',
      interestLevelLabel: 'Interest Level',
      interestLevelLow: 'Low',
      interestLevelMedium: 'Medium',
      interestLevelHigh: 'High',
      routeIndexPlaceholder: 'Route Index',
      routeIndexAsc: 'Route Index (Asc.)',
      routeIndexDesc: 'Route Index (Desc.)',
      importListTitle: 'Import Contact List',
      validMapsUrl: 'Enter a valid Google Maps URL',
      coordinatesFound: 'Location found: {{lat}}, {{lng}}',
      coordinatesExtractError: 'Could not extract coordinates. Use a valid Google Maps link.',
      noContactsToFix: 'No contacts to fix! All contacts already have coordinates.',
      processingContacts: 'Processing {{count}} contacts...',
      clearAllFilters: 'Clear all filters',
      addColumn: 'Add column',
      hiddenColumns: 'Hidden columns',
      filterColumn: 'Filter {{label}}',
      searchPlaceholder: 'Search...',
      hideColumn: 'Hide column',
      viewDetails: 'View Details',
      noteLabel: 'Note',
      toasts: {
        noContactsToFix: 'No contacts to fix! All contacts already have coordinates.',
        processingCount: 'Processing {{count}} contacts...',
        coordsUpdatedFor: 'Coordinates updated for {{name}}',
        batchCompleteCoords: 'Batch complete! Updated {{count}} contacts in database.',
        noContactsToUpdate: 'No contacts to update! All contacts with coordinates already have city.',
        cityUpdatedFor: 'City updated for {{name}}: {{city}}',
        batchCompleteCity: 'Batch complete! Updated {{count}} cities in database.',
        noContactsForRoute: 'No contacts with coordinates available for route optimization.',
        optimizingRoute: 'Optimizing route for {{count}} contacts...',
        cannotDetermineStart: 'Cannot determine starting point.',
        routeOptimized: 'Optimization complete! {{count}} contacts indexed.',
        routeError: 'Error during optimization: {{message}}'
      },
      empty: {
        noResults: 'No contacts found',
        noContactsYet: 'No contacts yet',
        tryFilters: 'Try changing search filters or add a new contact.',
        addFirst: 'Start by adding your first contact or importing a list.'
      },
      importModal: {
        uploadHint: 'Upload an Excel (.xlsx) or CSV file. The Excel file must contain the "Recovered_Sheet1" sheet with these columns:',
        noValidContacts: 'No valid contacts found in file',
        importedWithoutWebsite: 'Imported {{count}} contacts (without Website field - column not present in database).\n\nTo enable the Website field, run the SQL migration in file: supabase-migration-add-website-column.sql',
        importedCount: 'Imported {{count}} contacts',
        importError: 'Import error: {{message}}',
        importErrorWebsite: 'Import error: {{message}}\n\nNote: The \'website\' column does not exist in the database. Run the SQL migration to add it.',
        contactCreatedWithoutWebsite: 'Contact created (without Website field - column not present in database).\n\nTo enable the Website field, run the SQL migration in file: supabase-migration-add-website-column.sql',
        contactUpdatedWithoutWebsite: 'Contact updated (without Website field - column not present in database).\n\nTo enable the Website field, run the SQL migration in file: supabase-migration-add-website-column.sql',
        sheetNotFound: 'Sheet "Recovered_Sheet1" not found in Excel file',
        excelNeedsHeader: 'Excel file must contain at least one header and one data row',
        excelNeedsCompanyColumn: 'Excel file must contain the "Ragione Sociale" column.\n\nColumns found: {{columns}}',
        csvNeedsHeader: 'CSV must contain at least one header and one data row',
        csvNeedsNameColumn: 'CSV must contain a "Nome Attività" or "Name" column'
      }
    },
    leads: {
      title: 'Leads',
      subtitle: 'Track pipeline, metrics and follow-ups.',
      newLead: 'New lead',
      na: 'N/A',
      searchPlaceholder: 'Search by title or contact',
      filters: {
        stage: 'Stage',
        duplicates: 'Possible duplicates'
      },
      defaults: {
        untitled: 'Untitled lead',
        fallbackTitle: 'Lead',
        noName: 'No name',
        linkedContact: 'Linked contact'
      },
      createError: 'Lead creation error: {{message}}',
      deleteError: 'Lead deletion error: {{message}}',
      kpi: {
        totalContacts: 'Total contacts',
        totalLeads: 'Total leads',
        scheduled: 'Scheduled appointments',
        completed: 'Completed appointments',
        noShow: 'No-shows',
        conversion: 'Conversion rate',
        conversionDetail: '{{won}} won out of {{total}}'
      },
      pipelineSummary: 'Breakdown: {{breakdown}}',
      kpiSummary: 'Completed: {{completed}} · No-shows: {{noShow}}',
      pipeline: {
        headings: {
          new: 'New',
          qualified: 'Qualified',
          scheduled: 'Scheduled',
          won: 'Won',
          lost: 'Lost'
        },
        empty: 'Drag leads here to update their stage',
        staleBadge: 'follow-up',
        duplicateBadge: 'dup',
        duplicateMessage: 'Possible duplicate in the pipeline',
        unassigned: 'Contact not linked',
        lastUpdate: 'Last update',
        source: 'Source',
        emptyColumn: 'No leads in this column.'
      },
      followUps: {
        title: 'Follow-ups due',
        empty: 'All clear!'
      },
      modal: {
        newTitle: 'Create lead',
        editTitle: 'Edit lead',
        titleLabel: 'Title',
        valueLabel: 'Value (EUR)',
        stageLabel: 'Stage',
        selectContact: 'Select contact',
        newContactHeading: 'Create new contact',
        contactName: 'Name',
        contactPhone: 'Phone',
        contactEmail: 'Email',
        notes: 'Internal notes',
        notesPlaceholder: 'Add notes, details or relevant information about the lead...',
        attachedContact: 'Linked contact',
        addLead: 'Create lead',
        saveLead: 'Save',
        cancel: 'Cancel',
        deleteTitle: 'Delete lead',
        deleteText: 'Do you really want to delete {{title}}? This action cannot be undone.',
        details: 'Details',
        linkContact: 'Link contact',
        singleMode: 'Single mode',
        multiMode: 'Multi mode',
        contactDetailsNote: 'Contact details are modified from the contact card.',
        orCreateNew: '…or create a new contact',
        remove: 'Remove',
        loading: 'Loading…',
        selected: 'selected'
      }
    },
    appointments: {
      title: 'Scheduling & appointments',
      subtitle: 'Scheduling & Appointments',
      description: 'Manage slots, bookings and automatic reminders.',
      calendarSync: {
        title: 'Calendar sync',
        heading: 'Connect your calendar',
        description: 'Store the calendar link (ICS or CalDAV) to keep Launch appointments aligned with your personal schedule.',
        status: 'Status',
        edit: 'Edit',
        displayName: 'Display name',
        displayNamePlaceholder: 'e.g. Victor – Outlook',
        provider: 'Provider',
        providerManual: 'Manual (ICS link)',
        providerMicrosoft: 'Microsoft 365',
        providerCalendly: 'Calendly',
        icsLink: 'ICS / booking link',
        icsLinkPlaceholder: 'https://...',
        saveConnection: 'Save connection'
      },
      buildAvailability: {
        title: 'Build availability',
        description: 'Add time slots that the system can book automatically when leads pick a time.',
        startDateTime: 'Start date & time',
        duration: 'Duration (minutes)',
        calendar: 'Calendar',
        internalNotes: 'Internal notes',
        internalNotesPlaceholder: 'Optional details for the team',
        addSlot: 'Add slot'
      },
      availableSlots: {
        title: 'Available slots',
        subtitle: 'Ready to book',
        empty: 'No availability yet. Add a slot on the left to make booking windows available.',
        open: '{{count}} open',
        book: 'Book',
        cancel: 'Cancel'
      },
      bookedSlots: {
        title: 'Booked slots'
      },
      upcoming: {
        title: 'Upcoming appointments',
        subtitle: 'Next 20 bookings',
        scheduled: '{{count}} scheduled',
        empty: 'When an available slot is booked, it will appear here with contact details and status.',
        when: 'When',
        contact: 'Contact',
        subject: 'Title',
        status: 'Status',
        actions: 'Actions',
        join: 'Join',
        done: 'Done',
        cancel: 'Cancel'
      },
      modal: {
        bookTitle: 'Book slot',
        existingContact: 'Existing contact',
        selectContact: 'Select contact…',
        selectContactNone: 'None',
        searchContactPlaceholder: 'Search contact...',
        orCreateNew: 'Or create new',
        fullName: 'Full name',
        phone: 'Phone',
        phonePlaceholder: '+39 333…',
        email: 'Email (optional)',
        emailPlaceholder: 'client@example.com',
        title: 'Title',
        titlePlaceholder: 'Consultation call',
        notes: 'Notes',
        notesPlaceholder: 'Brief agenda',
        cancel: 'Cancel',
        confirmBooking: 'Confirm booking'
      },
      errors: {
        loadData: 'Unable to load scheduling data',
        createSlot: 'Unable to create slot',
        cancelSlot: 'Unable to cancel slot',
        bookAppointment: 'Unable to book appointment',
        updateAppointment: 'Unable to update appointment',
        deleteAppointment: 'Unable to delete appointment',
        deleteSlot: 'Unable to delete slot',
        saveConnection: 'Unable to save calendar connection',
        selectContact: 'Select an existing contact or provide details for a new one.',
        contactCreationFailed: 'Contact creation failed'
      },
      loading: 'Loading scheduling data…',
      delete: {
        title: 'Delete appointment',
        confirm: 'Are you sure you want to delete this appointment? This action cannot be undone.',
        button: 'Delete'
      },
      deleteSlot: {
        title: 'Delete slot',
        confirm: 'Are you sure you want to delete this booked slot? The associated appointment will also be deleted if present. This action cannot be undone.'
      }
    },
    reports: {
      title: 'Reports',
      subtitle: 'KPI overview and conversation trends.',
      loading: 'Loading metrics…',
      empty: 'No KPI data available yet. Interactions captured via WhatsApp, contacts and appointments will appear here automatically.',
      cards: {
        inboundMessages: 'Inbound messages',
        contactsCaptured: 'Contacts captured',
        leadsCreated: 'Leads created',
        appointmentsCompleted: 'Appointments completed',
        avgFirstResponse: 'Avg first response',
        vsPrevious: 'vs previous'
      },
      charts: {
        messagingVolume: 'Messaging volume',
        pipelineVelocity: 'Pipeline velocity'
      },
      table: {
        date: 'Date',
        period: 'Period',
        inbound: 'Inbound',
        outbound: 'Outbound',
        contacts: 'Contacts',
        leads: 'Leads',
        appointments: 'Appointments',
        avgResponse: 'Avg response',
        completed: 'Completed appointments'
      }
    },
    settings: {
      title: 'Settings · Users',
      subtitle: 'Manage workspace access.',
      users: {
        title: 'Users',
        loading: 'Loading…',
        adminOnly: 'Only admins can access this page.',
        email: 'Email',
        name: 'Name',
        role: 'Role',
        lastLogin: 'Last login',
        actions: 'Actions',
        resetPassword: 'Reset password',
        resetPasswordSending: 'Sending…',
        delete: 'Delete',
        deleteRemoving: 'Removing…'
      },
      invite: {
        title: 'Invite new user',
        email: 'Email',
        emailPlaceholder: 'Email',
        fullName: 'Full name',
        fullNamePlaceholder: 'Full name',
        role: 'Role',
        temporaryPassword: 'Temporary password',
        temporaryPasswordPlaceholder: 'Temporary password',
        sendEmail: 'Send invite email (user defines password)',
        passwordInstructions: 'An email will ask the user to choose their own password.',
        passwordManual: 'Share this password manually. No email will be sent.',
        inviteButton: 'Invite'
      },
      roleOptions: {
        owner: 'owner',
        admin: 'admin',
        agent: 'agent',
        viewer: 'viewer'
      },
      alerts: {
        notAllowed: 'Not allowed',
        missingWorkspace: 'Missing workspace',
        inviteFailed: 'Invite failed',
        resetSuccess: 'Password reset email sent',
        deleteSuccess: 'User removed',
        confirmDelete: 'Are you sure you want to remove this user?',
        roleChangeFailed: 'Role change failed',
        userHasNoEmail: 'User has no email',
        resetConfirmSelf: 'You are about to send yourself a password reset email. Continue?',
        resetConfirmOther: 'Send a password reset email to {{email}}?',
        sessionExpired: 'Session expired. Please log in again.',
        unableToSendReset: 'Unable to send reset email',
        resetSentSuccess: 'Reset email sent. Ask the user to check their inbox (and spam folder).',
        removeAccessConfirm: 'Remove access for {{email}}? This user will no longer be able to log in.',
        deleteSelfConfirm: 'You are deleting your own access. You will be signed out. Continue?',
        unableToDeleteUser: 'Unable to delete user'
      },
      pagination: {
        showing: 'Showing',
        of: 'of',
        users: 'users',
        previous: 'Previous',
        prevShort: 'Prev',
        next: 'Next',
        nextShort: 'Next'
      },
      roleLabel: 'Role',
      moreOptions: 'More Options'
    },
    detail: {
      contact: {
        timeline: 'Activity timeline',
        newNote: 'Add note',
        placeholder: 'Add a note…',
        save: 'Save note',
        loading: 'Loading…',
        deleteNoteConfirm: 'Are you sure you want to delete this note?',
        source: 'Source',
        company: 'Company',
        address: 'Address',
        openGoogleMaps: 'Open on Google Maps →',
        prospectStatus: 'Prospect Status',
        vat: 'VAT',
        rank: 'Rank',
        edit: 'Edit',
        editDetails: 'Edit details',
        additionalInfo: 'Additional info',
        created: 'Created',
        lastActivity: 'Last activity',
        preferredLanguagePlaceholder: 'Preferred language',
        zipPlaceholder: 'ZIP',
        googleMapsUrlPlaceholder: 'Google Maps URL',
        addNoteButton: 'Add',
        noActivityYet: 'No activity yet.',
        deleteNoteTitle: 'Delete note'
      },
      lead: {
        contactCard: 'Linked contact',
        timeline: 'Activity timeline',
        newNote: 'Add note',
        placeholder: 'Add a note…',
        save: 'Save note',
        loading: 'Loading…',
        back: 'Back',
        untitledLead: 'Untitled lead',
        potentialValue: 'Potential value: €',
        lastUpdate: 'Last update',
        deleteNoteConfirm: 'Are you sure you want to delete this note?',
        lostReason: 'Lost reason',
        lostReasonNotDocumented: 'Not documented yet.',
        whyLoseDeal: 'Why did we lose this deal?',
        saveLostReason: 'Save lost reason',
        markLost: 'Mark lost',
        hide: 'Hide',
        dealHygiene: 'Deal hygiene',
        appointments: 'Appointments',
        notesPlaceholder: 'e.g. call summary, next steps, budget details',
        noActivityYet: 'No activity yet.'
      },
      activityTypes: {
        whatsapp_inbound: 'WhatsApp (inbound)',
        whatsapp_outbound: 'WhatsApp (outbound)',
        review_request_sent: 'Review request',
        appointment_reminder: 'Appointment reminder',
        note: 'Note',
        activity: 'Activity'
      },
      activityChannels: {
        automation: 'Automation',
        web: 'CRM',
        whatsapp: 'WhatsApp'
      }
    },
    prospezione: {
      title: 'Prospecting',
      subtitle: 'Manage your list of contacts to visit',
      noContacts: 'No contacts',
      createCheckup: 'Create Check-up',
      createCheckupTitle: 'Create Check-up',
      createCheckupMessage: 'You will create a Lead and an Appointment for this contact. Do you want to proceed?',
      createCheckupConfirm: 'Create Check-up',
      createCheckupCancel: 'Cancel',
      details: 'Details',
      openMaps: 'Open on Maps',
      noName: 'No name',
      stages: {
        new: 'New',
        to_visit: 'To Visit',
        visited_interested: 'Visited - Interested',
        visited_not_interested: 'Visited - Not Interested',
        nurture: 'To Recontact',
        disqualified: 'Disqualified'
      },
      activity: {
        coldVisit: 'Cold visit'
      },
      kpi: {
        totalProspects: 'Total Prospects',
        conversionRate: 'Conversion Rate',
        visits: 'Visits',
        followUpDue: 'Follow-up Due',
        distributed: 'Distributed',
        interestedOutOf: '{{interested}} interested out of {{total}}',
        completed: 'Completed',
        toVisit: 'To visit',
        allUpToDate: 'All up to date!'
      },
      addProspect: 'Add Prospect',
      editProspect: 'Edit Prospect',
      newProspect: 'New Prospect',
      searchExistingContacts: 'Search Existing Contacts',
      leadCreationError: 'Lead creation error: {{message}}',
      contactUpdateError: 'Contact update error: {{message}}',
      updateError: 'Update error: {{message}}',
      createError: 'Create error: {{message}}'
    },
    navigator: {
      title: 'Navigator',
      subtitle: 'Select up to 10 contacts and view optimized route',
      addContact: 'Add Contact',
      selectContact: 'Select Contact',
      selectedContacts: 'Selected Contacts',
      noContactsSelected: 'No contacts selected',
      selectContactsHint: 'Click "Add Contact" to get started',
      generateRoute: 'Generate Route',
      navigate: 'Navigate',
      clear: 'Clear',
      remove: 'Remove',
      maxReached: 'You have reached the maximum limit of 10 contacts',
      noValidPoints: 'No valid points with coordinates',
      noAvailableContacts: 'No contacts available with Google Maps URL',
      noName: 'No name',
      removeConfirm: 'Remove this contact from the list?',
      moveUp: 'Move up',
      moveDown: 'Move down',
      openInGoogleMaps: 'Open in Google Maps',
      openMaps: 'Open Maps',
      resetRoute: 'Reset route',
      reset: 'Reset',
      clearList: 'Clear list',
      actions: 'Actions',
      interested: 'Interested',
      notInterested: 'Not Interested',
      visitDetailsPlaceholder: 'Enter visit details...',
      visitOutcome: 'Visit Outcome',
      addVisitDetailsPlaceholder: 'Add visit details...',
      confirmOutcome: 'Confirm Outcome',
      searchPlaceholder: 'Search by name, company, email, phone...',
      visitedShort: 'Visited',
      moveUpShort: 'Up',
      moveDownShort: 'Down',
      optimize: 'Optimize',
      optimizeRouteButton: 'Optimize Route',
      optimizing: 'Optimizing…',
      gettingLocation: 'Getting…',
      contactCount: '{{count}} contact',
      contactCountPlural: '{{count}} contacts',
      contactSingular: 'contact',
      contactPlural: 'contacts',
      stepCount: '{{count}} stop',
      stepCountPlural: '{{count}} stops',
      dragToReorder: 'Drag to reorder',
      shortLink: 'Short link',
      missingCoordinates: 'Missing coordinates',
      howDidVisitGo: 'How did the visit go?',
      visitNotesOptional: 'Visit Notes (Optional)',
      notesOptional: 'Notes (optional)',
      saving: 'Saving…',
      confirmVisit: 'Confirm Visit',
      searchContactsTitle: 'Search Contacts, Leads or Prospects',
      searchContactsHint: 'Search among contacts, leads and prospects with Google Maps address',
      noSearchResults: 'No results found. Try different search terms.',
      visitOutcomeNote: 'Visit outcome: {{outcome}}',
      visitNotesLabel: 'Notes',
      selectAtLeastOne: 'Select at least one contact',
      maxContactsReached: 'You can add only {{n}} contact(s) (max 10 total)',
      optimizedRoute: 'Optimized Route',
      optimizeFailed: 'Unable to optimize route...',
      optimizeFailedWithCoords: 'Unable to optimize route. Ensure contacts have valid coordinates.',
      optimizeFirst: 'Route not optimized. Click "Generate Route" first.',
      saveError: 'An error occurred while saving. Please try again.',
      clearAllConfirm: 'Are you sure you want to remove all contacts from the list?',
      errorPrefix: 'Error',
      convertToProspect: 'Convert to Prospect',
      convertToClient: 'Convert to Client',
      selectedCount: '{{n}} selected',
      selectedCountPlural: '{{n}} selected',
      slotsAvailable: '{{n}} slots available',
      deselect: 'Deselect',
      addWithCount: 'Add ({{n}})',
      add: 'Add',
      shortLinkNoCoords: 'Short link: coordinates not extractable'
    }
  },
  ru: {
    layout: {
      expandSidebar: 'Развернуть боковую панель',
      collapseSidebar: 'Свернуть боковую панель',
      closeMenu: 'Закрыть меню',
      back: 'Назад',
      openMenu: 'Открыть меню',
      poweredBy: 'Разработано',
      loadingWorkspace: 'Загрузка рабочей области…'
    },
    navigation: {
      brand: 'Sales Navigator',
      contacts: 'Контакты',
      leads: 'Лиды',
      prospezione: 'Проспекция',
      navigator: 'Навигатор',
      appointments: 'Встречи',
      reports: 'Отчёты',
      settings: 'Настройки · Пользователи',
      logout: 'Выйти'
    },
    common: {
      loading: 'Загрузка…',
      searchPlaceholder: 'Поиск по имени/email/телефону',
      filterSource: 'Источник',
      filterTag: 'Тег',
      filterStage: 'Тип',
      sortRecent: 'Сначала новые',
      sortName: 'Сортировать по имени',
      buttons: {
        new: 'Новый',
        create: 'Создать',
        save: 'Сохранить',
        edit: 'Изменить',
        delete: 'Удалить',
        cancel: 'Отмена',
        close: 'Закрыть',
        open: 'Открыть'
      },
      stages: {
        contact: 'Контакт',
        lead: 'Лид',
        client: 'Клиент',
        prospect: 'Проспект'
      },
      relative: {
        today: 'сегодня',
        yesterday: 'вчера',
        daysAgo: '{{count}} дн. назад'
      },
      openLeadBadge: '{{count}} лидов',
      selected: '{{count}} выбрано'
    },
    contacts: {
      title: 'Контакты',
      subtitle: 'Управление контактами и мониторинг активности.',
      newButton: 'Новый контакт',
      summary: '{{count}} результатов · дубликаты email: {{duplicateEmails}} · дубликаты телефона: {{duplicatePhones}}',
      columns: {
        name: 'Имя',
        company: 'Компания',
        email: 'Email',
        phone: 'Телефон',
        source: 'Источник',
        stage: 'Тип',
        address: 'Адрес',
        city: 'Город',
        prospectStatus: 'Статус проспекции',
        leadStatus: 'Статус лида',
        tags: 'Теги',
        interest_level: 'Уровень интереса',
        route_index: 'Индекс маршрута',
        vat: 'ИНН',
        rank: 'Ранг',
        lastActivity: 'Последняя активность',
        website: 'Сайт',
        googleMaps: 'Google Maps',
        whatsapp: 'WhatsApp',
        latest_note: 'Заметка',
        actions: 'Действия'
      },
      noTag: '—',
      noRank: 'Не назначен',
      duplicateBadge: 'дуп',
      addToNavigator: 'Добавить в навигатор',
      alreadyInNavigator: 'Уже в навигаторе',
      addedToNavigator: 'Контакт добавлен в навигатор',
      drawer: {
        newTitle: 'Новый контакт',
        editTitle: 'Редактировать контакт',
        fullName: 'Полное имя',
        email: 'Email',
        phone: 'Телефон',
        source: 'Источник',
        tags: 'Теги (через запятую)',
        vat: 'ИНН',
        rank: 'Ранг клиента',
        rankPlaceholder: 'Не назначен',
        stage: 'Тип',
        typeLabel: 'Тип',
        leadStatusLabel: 'Статус лида',
        prospectStatusLabel: 'Статус проспекции',
        contactTypeOption: 'Контакт',
        leadTypeOption: 'Лид',
        prospectTypeOption: 'Проспект'
      },
      delete: {
        title: 'Удалить контакт',
        message: 'Вы уверены, что хотите удалить {{name}}? Это действие нельзя отменить.',
        confirm: 'Удалить',
        cancel: 'Отмена',
        error: 'Ошибка удаления: {{message}}'
      },
      import: 'Импорт',
      findCoordinates: 'Найти координаты',
      findCoordinatesFor: 'Найти координаты для {{count}} контактов',
      fixing: 'Исправление…',
      updateCity: 'Обновить город',
      updateCityFor: 'Обновить город для {{count}} контактов',
      updating: 'Обновление…',
      optimizeRoute: 'Оптимизировать маршрут',
      optimizeRouteFor: 'Оптимизировать маршрут и назначить индексы для {{count}} контактов',
      optimizing: 'Оптимизация…',
      noTagsAvailable: 'Нет доступных тегов',
      noCitiesAvailable: 'Нет доступных городов',
      importList: 'Импорт списка',
      pagination: { showing: 'Показано', of: 'из', contacts: 'контактов', previous: 'Назад', prevShort: 'Назад', next: 'Вперёд', nextShort: 'Вперёд' },
      previous: 'Назад',
      prevShort: 'Назад',
      next: 'Вперёд',
      nextShort: 'Вперёд',
      placeholderCompany: 'Компания',
      placeholderRole: 'Роль',
      interestLevelLabel: 'Уровень интереса',
      interestLevelLow: 'Низкий',
      interestLevelMedium: 'Средний',
      interestLevelHigh: 'Высокий',
      routeIndexPlaceholder: 'Индекс маршрута',
      routeIndexAsc: 'Индекс маршрута (возр.)',
      routeIndexDesc: 'Индекс маршрута (убыв.)',
      importListTitle: 'Импорт списка контактов',
      validMapsUrl: 'Введите корректный URL Google Maps',
      coordinatesFound: 'Местоположение найдено: {{lat}}, {{lng}}',
      coordinatesExtractError: 'Не удалось извлечь координаты. Используйте корректную ссылку Google Maps.',
      noContactsToFix: 'Нет контактов для исправления! У всех контактов уже есть координаты.',
      processingContacts: 'Обработка {{count}} контактов...',
      clearAllFilters: 'Сбросить все фильтры',
      addColumn: 'Добавить столбец',
      hiddenColumns: 'Скрытые столбцы',
      filterColumn: 'Фильтр {{label}}',
      searchPlaceholder: 'Поиск...',
      hideColumn: 'Скрыть столбец',
      viewDetails: 'Просмотр деталей',
      noteLabel: 'Заметка',
      toasts: {
        noContactsToFix: 'Нет контактов для исправления! У всех контактов уже есть координаты.',
        processingCount: 'Обработка {{count}} контактов...',
        coordsUpdatedFor: 'Координаты обновлены для {{name}}',
        batchCompleteCoords: 'Пакет завершён! Обновлено {{count}} контактов в базе данных.',
        noContactsToUpdate: 'Нет контактов для обновления! У всех контактов с координатами уже есть город.',
        cityUpdatedFor: 'Город обновлён для {{name}}: {{city}}',
        batchCompleteCity: 'Пакет завершён! Обновлено {{count}} городов в базе данных.',
        noContactsForRoute: 'Нет контактов с координатами для оптимизации маршрута.',
        optimizingRoute: 'Оптимизация маршрута для {{count}} контактов...',
        cannotDetermineStart: 'Невозможно определить начальную точку.',
        routeOptimized: 'Оптимизация завершена! {{count}} контактов проиндексировано.',
        routeError: 'Ошибка при оптимизации: {{message}}'
      },
      empty: {
        noResults: 'Контакты не найдены',
        noContactsYet: 'Пока нет контактов',
        tryFilters: 'Попробуйте изменить фильтры поиска или добавьте новый контакт.',
        addFirst: 'Начните с добавления первого контакта или импорта списка.'
      },
      importModal: {
        uploadHint: 'Загрузите файл Excel (.xlsx) или CSV. Файл Excel должен содержать лист "Recovered_Sheet1" с этими колонками:',
        noValidContacts: 'В файле не найдено действительных контактов',
        importedWithoutWebsite: 'Импортировано {{count}} контактов (без поля Website - колонка отсутствует в базе данных).\n\nЧтобы включить поле Website, выполните SQL-миграцию в файле: supabase-migration-add-website-column.sql',
        importedCount: 'Импортировано {{count}} контактов',
        importError: 'Ошибка импорта: {{message}}',
        importErrorWebsite: 'Ошибка импорта: {{message}}\n\nПримечание: Колонка \'website\' отсутствует в базе данных. Выполните SQL-миграцию для её добавления.',
        contactCreatedWithoutWebsite: 'Контакт создан (без поля Website - колонка отсутствует в базе данных).\n\nЧтобы включить поле Website, выполните SQL-миграцию в файле: supabase-migration-add-website-column.sql',
        contactUpdatedWithoutWebsite: 'Контакт обновлён (без поля Website - колонка отсутствует в базе данных).\n\nЧтобы включить поле Website, выполните SQL-миграцию в файле: supabase-migration-add-website-column.sql',
        sheetNotFound: 'Лист "Recovered_Sheet1" не найден в файле Excel',
        excelNeedsHeader: 'Файл Excel должен содержать хотя бы один заголовок и одну строку данных',
        excelNeedsCompanyColumn: 'Файл Excel должен содержать колонку "Ragione Sociale".\n\nНайденные колонки: {{columns}}',
        csvNeedsHeader: 'CSV должен содержать хотя бы один заголовок и одну строку данных',
        csvNeedsNameColumn: 'CSV должен содержать колонку "Nome Attività" или "Name"'
      }
    },
    leads: {
      title: 'Лиды',
      subtitle: 'Отслеживание воронки, метрик и последующих действий.',
      newLead: 'Новый лид',
      na: 'Н/Д',
      searchPlaceholder: 'Поиск по названию или контакту',
      filters: {
        stage: 'Этап',
        duplicates: 'Возможные дубликаты'
      },
      defaults: {
        untitled: 'Лид без названия',
        fallbackTitle: 'Лид',
        noName: 'Без имени',
        linkedContact: 'Связанный контакт'
      },
      createError: 'Ошибка создания лида: {{message}}',
      deleteError: 'Ошибка удаления лида: {{message}}',
      kpi: {
        totalContacts: 'Всего контактов',
        totalLeads: 'Всего лидов',
        scheduled: 'Запланированные встречи',
        completed: 'Завершённые встречи',
        noShow: 'Неявки',
        conversion: 'Конверсия',
        conversionDetail: '{{won}} выиграно из {{total}}'
      },
      pipelineSummary: 'Распределение: {{breakdown}}',
      kpiSummary: 'Завершено: {{completed}} · Неявки: {{noShow}}',
      pipeline: {
        headings: {
          new: 'Новые',
          qualified: 'Квалифицированные',
          scheduled: 'Запланированные',
          won: 'Выиграны',
          lost: 'Потеряны'
        },
        empty: 'Перетащите лиды сюда для обновления статуса',
        staleBadge: 'требуется follow-up',
        duplicateBadge: 'дуп',
        duplicateMessage: 'Возможный дубликат в воронке',
        unassigned: 'Контакт не связан',
        lastUpdate: 'Последнее обновление',
        source: 'Источник',
        emptyColumn: 'В этой колонке нет лидов.'
      },
      followUps: {
        title: 'Требуются follow-up',
        empty: 'Всё в порядке!'
      },
      modal: {
        newTitle: 'Новый лид',
        editTitle: 'Редактировать лид',
        titleLabel: 'Название',
        valueLabel: 'Стоимость (EUR)',
        stageLabel: 'Этап',
        selectContact: 'Выбрать контакт',
        newContactHeading: 'Создать новый контакт',
        contactName: 'Имя',
        contactPhone: 'Телефон',
        contactEmail: 'Email',
        notes: 'Внутренние заметки',
        notesPlaceholder: 'Добавьте заметки, детали или информацию о лиде...',
        attachedContact: 'Связанный контакт',
        addLead: 'Создать лид',
        saveLead: 'Сохранить',
        cancel: 'Отмена',
        deleteTitle: 'Удалить лид',
        deleteText: 'Вы уверены, что хотите удалить {{title}}? Это действие нельзя отменить.',
        details: 'Детали',
        linkContact: 'Связать контакт',
        singleMode: 'Одиночный режим',
        multiMode: 'Множественный режим',
        contactDetailsNote: 'Данные контакта изменяются в карточке контакта.',
        orCreateNew: '…или создать новый контакт',
        remove: 'Удалить',
        loading: 'Загрузка…',
        selected: 'выбрано'
      }
    },
    appointments: {
      title: 'Расписание и встречи',
      subtitle: 'Планирование и встречи',
      description: 'Управление слотами, бронированиями и напоминаниями.',
      calendarSync: {
        title: 'Синхронизация календаря',
        heading: 'Подключите календарь',
        description: 'Сохраните ссылку на календарь (ICS или CalDAV) для синхронизации встреч с личным расписанием.',
        status: 'Статус',
        edit: 'Изменить',
        displayName: 'Отображаемое имя',
        displayNamePlaceholder: 'напр. Victor – Outlook',
        provider: 'Провайдер',
        providerManual: 'Вручную (ссылка ICS)',
        providerMicrosoft: 'Microsoft 365',
        providerCalendly: 'Calendly',
        icsLink: 'Ссылка ICS / бронирование',
        icsLinkPlaceholder: 'https://...',
        saveConnection: 'Сохранить подключение'
      },
      buildAvailability: {
        title: 'Создать доступность',
        description: 'Добавьте временные слоты для автоматического бронирования.',
        startDateTime: 'Дата и время начала',
        duration: 'Длительность (минуты)',
        calendar: 'Календарь',
        internalNotes: 'Внутренние заметки',
        internalNotesPlaceholder: 'Опциональные детали для команды',
        addSlot: 'Добавить слот'
      },
      availableSlots: {
        title: 'Доступные слоты',
        subtitle: 'Готовы к бронированию',
        empty: 'Нет доступных слотов. Добавьте слот слева.',
        open: '{{count}} открыто',
        book: 'Забронировать',
        cancel: 'Отмена'
      },
      bookedSlots: {
        title: 'Забронированные слоты'
      },
      upcoming: {
        title: 'Предстоящие встречи',
        subtitle: 'Ближайшие 20 встреч',
        scheduled: '{{count}} запланировано',
        empty: 'Забронированные слоты появятся здесь с деталями контакта.',
        when: 'Когда',
        contact: 'Контакт',
        subject: 'Название',
        status: 'Статус',
        actions: 'Действия',
        join: 'Присоединиться',
        done: 'Выполнено',
        cancel: 'Отмена'
      },
      modal: {
        bookTitle: 'Забронировать слот',
        existingContact: 'Существующий контакт',
        selectContact: 'Выбрать контакт…',
        selectContactNone: 'Нет',
        searchContactPlaceholder: 'Поиск контакта...',
        orCreateNew: 'Или создать новый',
        fullName: 'Полное имя',
        phone: 'Телефон',
        phonePlaceholder: '+7 999…',
        email: 'Email (опционально)',
        emailPlaceholder: 'client@example.com',
        title: 'Название',
        titlePlaceholder: 'Консультационный звонок',
        notes: 'Заметки',
        notesPlaceholder: 'Краткая повестка',
        cancel: 'Отмена',
        confirmBooking: 'Подтвердить бронирование'
      },
      errors: {
        loadData: 'Не удалось загрузить данные планирования',
        createSlot: 'Не удалось создать слот',
        cancelSlot: 'Не удалось отменить слот',
        bookAppointment: 'Не удалось забронировать встречу',
        updateAppointment: 'Не удалось обновить встречу',
        deleteAppointment: 'Не удалось удалить встречу',
        deleteSlot: 'Не удалось удалить слот',
        saveConnection: 'Не удалось сохранить подключение календаря',
        selectContact: 'Выберите существующий контакт или укажите данные для нового.',
        contactCreationFailed: 'Не удалось создать контакт'
      },
      loading: 'Загрузка данных планирования…',
      delete: {
        title: 'Удалить встречу',
        confirm: 'Вы уверены, что хотите удалить эту встречу? Это действие нельзя отменить.',
        button: 'Удалить'
      },
      deleteSlot: {
        title: 'Удалить слот',
        confirm: 'Вы уверены, что хотите удалить этот забронированный слот? Связанная встреча также будет удалена. Это действие нельзя отменить.'
      }
    },
    reports: {
      title: 'Отчёты',
      subtitle: 'Обзор KPI и тренды.',
      loading: 'Загрузка метрик…',
      empty: 'Нет данных KPI. Взаимодействия через WhatsApp, контакты и встречи появятся здесь автоматически.',
      cards: {
        inboundMessages: 'Входящие сообщения',
        contactsCaptured: 'Полученные контакты',
        leadsCreated: 'Созданные лиды',
        appointmentsCompleted: 'Завершённые встречи',
        avgFirstResponse: 'Среднее время первого ответа',
        vsPrevious: 'к предыдущему'
      },
      charts: {
        messagingVolume: 'Объём сообщений',
        pipelineVelocity: 'Скорость воронки'
      },
      table: {
        date: 'Дата',
        period: 'Период',
        inbound: 'Входящие',
        outbound: 'Исходящие',
        contacts: 'Контакты',
        leads: 'Лиды',
        appointments: 'Встречи',
        avgResponse: 'Среднее время ответа',
        completed: 'Завершённые встречи'
      }
    },
    settings: {
      title: 'Настройки · Пользователи',
      subtitle: 'Управление доступом к рабочей области.',
      users: {
        title: 'Пользователи',
        loading: 'Загрузка…',
        adminOnly: 'Только администраторы имеют доступ к этой странице.',
        email: 'Email',
        name: 'Имя',
        role: 'Роль',
        lastLogin: 'Последний вход',
        actions: 'Действия',
        resetPassword: 'Сбросить пароль',
        resetPasswordSending: 'Отправка…',
        delete: 'Удалить',
        deleteRemoving: 'Удаление…'
      },
      invite: {
        title: 'Пригласить пользователя',
        email: 'Email',
        emailPlaceholder: 'Email',
        fullName: 'Полное имя',
        fullNamePlaceholder: 'Полное имя',
        role: 'Роль',
        temporaryPassword: 'Временный пароль',
        temporaryPasswordPlaceholder: 'Временный пароль',
        sendEmail: 'Отправить email-приглашение (пользователь задаёт пароль)',
        passwordInstructions: 'Email попросит пользователя выбрать пароль.',
        passwordManual: 'Передайте пароль вручную. Email не будет отправлен.',
        inviteButton: 'Пригласить'
      },
      roleOptions: {
        owner: 'владелец',
        admin: 'администратор',
        agent: 'агент',
        viewer: 'наблюдатель'
      },
      alerts: {
        notAllowed: 'Не разрешено',
        missingWorkspace: 'Рабочая область не найдена',
        inviteFailed: 'Не удалось пригласить',
        resetSuccess: 'Письмо для сброса пароля отправлено',
        deleteSuccess: 'Пользователь удалён',
        confirmDelete: 'Вы уверены, что хотите удалить этого пользователя?',
        roleChangeFailed: 'Не удалось изменить роль',
        userHasNoEmail: 'У пользователя нет email',
        resetConfirmSelf: 'Вы собираетесь отправить себе письмо для сброса пароля. Продолжить?',
        resetConfirmOther: 'Отправить письмо для сброса пароля на {{email}}?',
        sessionExpired: 'Сессия истекла. Войдите снова.',
        unableToSendReset: 'Не удалось отправить письмо для сброса',
        resetSentSuccess: 'Письмо отправлено. Попросите пользователя проверить почту (и папку «Спам»).',
        removeAccessConfirm: 'Удалить доступ для {{email}}? Пользователь больше не сможет войти.',
        deleteSelfConfirm: 'Вы удаляете свой доступ. Вы будете разлогинены. Продолжить?',
        unableToDeleteUser: 'Не удалось удалить пользователя'
      },
      pagination: {
        showing: 'Показано',
        of: 'из',
        users: 'пользователей',
        previous: 'Назад',
        prevShort: 'Назад',
        next: 'Вперёд',
        nextShort: 'Вперёд'
      },
      roleLabel: 'Роль',
      moreOptions: 'Дополнительно'
    },
    detail: {
      contact: {
        timeline: 'История активности',
        newNote: 'Добавить заметку',
        placeholder: 'Добавьте заметку…',
        save: 'Сохранить заметку',
        loading: 'Загрузка…',
        deleteNoteConfirm: 'Вы уверены, что хотите удалить эту заметку?',
        source: 'Источник',
        company: 'Компания',
        address: 'Адрес',
        openGoogleMaps: 'Открыть в Google Maps →',
        prospectStatus: 'Статус проспекции',
        vat: 'ИНН',
        rank: 'Ранг',
        edit: 'Изменить',
        editDetails: 'Редактировать',
        additionalInfo: 'Дополнительно',
        created: 'Создан',
        lastActivity: 'Последняя активность',
        preferredLanguagePlaceholder: 'Предпочитаемый язык',
        zipPlaceholder: 'Индекс',
        googleMapsUrlPlaceholder: 'URL Google Maps',
        addNoteButton: 'Добавить',
        noActivityYet: 'Пока нет активности.',
        deleteNoteTitle: 'Удалить заметку'
      },
      lead: {
        contactCard: 'Связанный контакт',
        timeline: 'История активности',
        newNote: 'Добавить заметку',
        placeholder: 'Добавьте заметку…',
        save: 'Сохранить заметку',
        loading: 'Загрузка…',
        back: 'Назад',
        untitledLead: 'Лид без названия',
        potentialValue: 'Потенциальная стоимость: €',
        lastUpdate: 'Последнее обновление',
        deleteNoteConfirm: 'Вы уверены, что хотите удалить эту заметку?',
        lostReason: 'Причина потери',
        lostReasonNotDocumented: 'Пока не задокументировано.',
        whyLoseDeal: 'Почему мы потеряли эту сделку?',
        saveLostReason: 'Сохранить причину потери',
        markLost: 'Отметить как потерянную',
        hide: 'Скрыть',
        dealHygiene: 'Гигиена сделки',
        appointments: 'Встречи',
        notesPlaceholder: 'Напр.: итоги звонка, следующие шаги, детали по бюджету',
        noActivityYet: 'Пока нет активности.'
      },
      activityTypes: {
        whatsapp_inbound: 'WhatsApp (входящий)',
        whatsapp_outbound: 'WhatsApp (исходящий)',
        review_request_sent: 'Запрос отзыва',
        appointment_reminder: 'Напоминание о встрече',
        note: 'Заметка',
        activity: 'Активность'
      },
      activityChannels: {
        automation: 'Автоматизация',
        web: 'CRM',
        whatsapp: 'WhatsApp'
      }
    },
    prospezione: {
      title: 'Проспекция',
      subtitle: 'Управление списком контактов для посещения',
      noContacts: 'Нет контактов',
      createCheckup: 'Создать Check-up',
      createCheckupTitle: 'Создать Check-up',
      createCheckupMessage: 'Будет создан лид и встреча для этого контакта. Продолжить?',
      createCheckupConfirm: 'Создать Check-up',
      createCheckupCancel: 'Отмена',
      details: 'Детали',
      openMaps: 'Открыть в Maps',
      noName: 'Без имени',
      stages: {
        new: 'Новый',
        to_visit: 'К посещению',
        visited_interested: 'Посещён — заинтересован',
        visited_not_interested: 'Посещён — не заинтересован',
        nurture: 'На повторный контакт',
        disqualified: 'Дисквалифицирован'
      },
      activity: {
        coldVisit: 'Холодный визит'
      },
      kpi: {
        totalProspects: 'Всего проспектов',
        conversionRate: 'Конверсия',
        visits: 'Визиты',
        followUpDue: 'Требуются follow-up',
        distributed: 'Распределено',
        interestedOutOf: '{{interested}} заинтересовано из {{total}}',
        completed: 'Завершено',
        toVisit: 'К посещению',
        allUpToDate: 'Всё актуально!'
      },
      addProspect: 'Добавить проспект',
      editProspect: 'Редактировать проспект',
      newProspect: 'Новый проспект',
      searchExistingContacts: 'Поиск существующих контактов',
      leadCreationError: 'Ошибка создания лида: {{message}}',
      contactUpdateError: 'Ошибка обновления контактов: {{message}}',
      updateError: 'Ошибка обновления: {{message}}',
      createError: 'Ошибка создания: {{message}}'
    },
    navigator: {
      title: 'Навигатор',
      subtitle: 'Выберите до 10 контактов и просмотрите оптимизированный маршрут',
      addContact: 'Добавить контакт',
      selectContact: 'Выбрать контакт',
      selectedContacts: 'Выбранные контакты',
      noContactsSelected: 'Нет выбранных контактов',
      selectContactsHint: 'Нажмите «Добавить контакт» для начала',
      generateRoute: 'Построить маршрут',
      navigate: 'Маршрут',
      clear: 'Очистить',
      remove: 'Удалить',
      maxReached: 'Достигнут лимит 10 контактов',
      noValidPoints: 'Нет точек с координатами',
      noAvailableContacts: 'Нет контактов с URL Google Maps',
      noName: 'Без имени',
      removeConfirm: 'Удалить этот контакт из списка?',
      moveUp: 'Вверх',
      moveDown: 'Вниз',
      openInGoogleMaps: 'Открыть в Google Maps',
      openMaps: 'Открыть Maps',
      resetRoute: 'Сбросить маршрут',
      reset: 'Сброс',
      clearList: 'Очистить список',
      actions: 'Действия',
      interested: 'Заинтересован',
      notInterested: 'Не заинтересован',
      visitDetailsPlaceholder: 'Введите детали визита...',
      visitOutcome: 'Результат визита',
      addVisitDetailsPlaceholder: 'Добавьте детали визита...',
      confirmOutcome: 'Подтвердить результат',
      searchPlaceholder: 'Поиск по имени, компании, email, телефону...',
      visitedShort: 'Посещён',
      moveUpShort: 'Вверх',
      moveDownShort: 'Вниз',
      optimize: 'Оптимизировать',
      optimizeRouteButton: 'Оптимизировать маршрут',
      optimizing: 'Оптимизация…',
      gettingLocation: 'Получение…',
      contactCount: '{{count}} контакт',
      contactCountPlural: '{{count}} контактов',
      contactSingular: 'контакт',
      contactPlural: 'контактов',
      stepCount: '{{count}} остановка',
      stepCountPlural: '{{count}} остановок',
      dragToReorder: 'Перетащите для изменения порядка',
      shortLink: 'Короткая ссылка',
      missingCoordinates: 'Координаты отсутствуют',
      howDidVisitGo: 'Как прошёл визит?',
      visitNotesOptional: 'Заметки о визите (опционально)',
      notesOptional: 'Заметки (опционально)',
      saving: 'Сохранение…',
      confirmVisit: 'Подтвердить визит',
      searchContactsTitle: 'Поиск контактов, лидов или проспектов',
      searchContactsHint: 'Поиск среди контактов, лидов и проспектов с адресом Google Maps',
      noSearchResults: 'Ничего не найдено. Попробуйте другие поисковые запросы.',
      visitOutcomeNote: 'Результат визита: {{outcome}}',
      visitNotesLabel: 'Заметки',
      selectAtLeastOne: 'Выберите хотя бы один контакт',
      maxContactsReached: 'Можно добавить только {{n}} контакт(ов) (максимум 10)',
      optimizedRoute: 'Оптимизированный маршрут',
      optimizeFailed: 'Не удалось оптимизировать маршрут...',
      optimizeFailedWithCoords: 'Не удалось оптимизировать маршрут. Убедитесь, что у контактов есть координаты.',
      optimizeFirst: 'Маршрут не оптимизирован. Сначала нажмите «Построить маршрут».',
      saveError: 'Произошла ошибка при сохранении. Попробуйте снова.',
      clearAllConfirm: 'Вы уверены, что хотите удалить все контакты из списка?',
      errorPrefix: 'Ошибка',
      convertToProspect: 'Преобразовать в проспект',
      convertToClient: 'Преобразовать в клиента',
      selectedCount: '{{n}} выбрано',
      selectedCountPlural: '{{n}} выбрано',
      slotsAvailable: '{{n}} слотов доступно',
      deselect: 'Снять выделение',
      addWithCount: 'Добавить ({{n}})',
      add: 'Добавить',
      shortLinkNoCoords: 'Короткая ссылка: координаты недоступны'
    }
  }
};

